// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #FBFCFE;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-5: #0042A6;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #CCEDFF;
  --color-mima-light: #EEF2F5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-grey-6: #9898AB;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-red: #FFE8E8;
  --color-light-grey: #F3F3FF;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.MimaInput_form__HrJaF {
  display: block;
}
.MimaInput_form__group__WVOmY:not(:last-child) {
  margin-bottom: 1rem;
}
.MimaInput_form__input__r5iYU {
  font-size: 1.8rem;
  font-family: inherit;
  color: var(--color-dark);
  padding-left: 2rem;
  width: 100%;
  height: 6rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
  margin-top: 0.5rem;
}
.MimaInput_form__input__r5iYU:focus, .MimaInput_form__input__r5iYU:focus-visible, .MimaInput_form__input__r5iYU:focus-within {
  color: var(--color-dark);
  border: 1px solid #1f68d6;
}
.MimaInput_form__input_filter__zDB96 {
  font-size: var(--default-font-small);
  font-family: inherit;
  color: var(--color-dark);
  padding-left: 2rem;
  width: 100%;
  height: 4rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
  margin-top: 0.5rem;
}
.MimaInput_form__input_filter__zDB96:focus, .MimaInput_form__input_filter__zDB96:focus-visible, .MimaInput_form__input_filter__zDB96:focus-within {
  color: var(--color-dark);
  border: 1px solid #1f68d6;
}
.MimaInput_form__label__FIG4x {
  font-size: 1.4rem;
  font-family: inherit;
  padding-left: 2rem;
  box-sizing: border-box;
  width: 38rem;
}
.MimaInput_form__calendar__BG5qm {
  font-family: inherit;
  font-size: 1.4rem;
  background-color: var(--color-white);
  color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 1rem;
  border: none;
  width: 25rem;
  height: 27.5rem;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 5px;
}
.MimaInput_form__calendar__BG5qm > :nth-child(3) {
  background-color: var(--color-dark);
  left: 1rem;
  top: 1rem;
  border-radius: 0.8rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(3):hover {
  background-color: var(--color-primary-4);
}
.MimaInput_form__calendar__BG5qm > :nth-child(3) span::before {
  right: -0.3rem;
  top: 0.7rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(4) {
  background-color: var(--color-dark);
  right: 1rem !important;
  top: 1rem;
  border-radius: 0.8rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(4):hover {
  background-color: var(--color-primary-4);
}
.MimaInput_form__calendar__BG5qm > :nth-child(4) span::before {
  left: -0.3rem;
  top: 0.7rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) {
  width: 100%;
  font-family: "Montserrat";
  font-size: 1.4rem;
  background-color: var(--color-light);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(1) {
  background-color: var(--color-primary-3);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(1) > :nth-child(1) {
  font-size: 1.4rem;
  color: var(--color-primary);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(1) > :nth-child(3) {
  font-weight: 700;
  color: var(--color-dark);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(2) > :nth-child(even) {
  background-color: var(--color-primary-7);
}
.MimaInput_form__calendar__BG5qm > :nth-child(5) > :nth-child(2) > * {
  color: var(--color-dark);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  height: 3rem;
}
.MimaInput_form__calendar__BG5qm > :nth-child(6) {
  font-family: "Montserrat";
  font-size: var(--default-font-small);
  position: absolute;
  right: -85px;
}
.MimaInput_form__calendar__BG5qm > :nth-child(6) > :nth-child(1) > * {
  font-size: var(--default-font-xsmall) !important;
}

.MimaInput_filled__lg89T {
  color: var(--color-dark);
}

.MimaInput_error__QkKJM {
  font-size: var(--default-font-small);
  color: var(--color-error);
  font-weight: 400;
  margin: 1rem 0;
  max-width: 38rem;
}

.MimaInput_note__rddKG {
  display: flex;
  align-items: center;
  font-size: var(--default-font-xsmall);
  color: var(--color-primary);
  font-weight: 400;
  margin: 1rem 0;
}

.MimaInput_pageCount__q1trw {
  font-size: var(--default-font-small);
  font-weight: 700;
  margin: 1rem 0;
  max-width: 38rem;
}

.MimaInput_success__h3__1dGfk {
  color: var(--color-success);
  font-size: var(--default-font-h3);
  font-weight: 700;
  line-height: 3.5rem;
}

.MimaInput_iconAlign__3NiB0 {
  max-height: 6rem;
  position: relative;
}
.MimaInput_iconAlign__3NiB0 > :nth-child(2) {
  position: absolute;
  left: 0;
}

.MimaInput_tag__HOPrF {
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
  height: 4rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  width: 15rem;
  margin-top: 1rem;
  margin-right: 1rem;
}
.MimaInput_tag_close__CPSWl {
  display: block;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
}

.MimaInput_tags__JdTMp {
  display: flex;
  flex-wrap: wrap;
}
.MimaInput_tags__JdTMp > :not(:last-child) {
  margin-right: 1rem;
}

.MimaInput_singleTag__G0kUc {
  display: flex;
  font-size: var(--default-font-small);
  align-items: center;
  background-color: var(--color-primary-3);
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.MimaInput_singleTag__G0kUc > :not(:last-child) {
  margin-right: 0.5rem;
}
.MimaInput_singleTag__G0kUc:hover {
  color: var(--color-primary);
}

.MimaInput_suggestions__aMe2F {
  padding: 0.5rem;
  font-size: var(--default-font-small);
  cursor: pointer;
  background-color: var(--color-dark);
  border-radius: 0.5rem;
  color: var(--color-white);
}
.MimaInput_suggestions__all__1BQjb {
  display: flex;
  flex-wrap: wrap;
}
.MimaInput_suggestions__all__1BQjb > :not(:last-child) {
  margin-right: 0.5rem;
}

.MimaInput_dateInput__JI0Z8 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/MimaInput.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;ACTD;;AArDA;EACC,cAAA;AAwDD;AAtDC;EACC,mBAAA;AAwDF;AArDC;EACC,iBDuFkB;ECtFlB,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;AAuDF;AArDE;EAGC,wBAAA;EACA,yBAAA;AAqDH;AAlDE;EACC,oCAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;AAoDH;AAlDG;EAGC,wBAAA;EACA,yBAAA;AAkDJ;AA7CC;EACC,iBDkDmB;ECjDnB,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AA+CF;AA5CC;EACC,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,wBAAA;EACA,4CAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AA8CF;AA5CE;EACC,mCAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;AA8CH;AA5CG;EACC,wCAAA;AA8CJ;AA3CG;EACC,cAAA;EACA,WAAA;AA6CJ;AA1CE;EACC,mCAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AA4CH;AA3CG;EACC,wCAAA;AA6CJ;AA3CG;EACC,aAAA;EACA,WAAA;AA6CJ;AAzCE;EACC,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,oCAAA;AA2CH;AAzCG;EACC,wCAAA;AA2CJ;AA1CI;EACC,iBAAA;EACA,2BAAA;AA4CL;AAzCI;EACC,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,qCAAA;AA2CL;AAtCI;EACC,wCAAA;AAwCL;AAtCI;EACC,wBAAA;EACA,aAAA;EACA,qCAAA;EACA,YAAA;AAwCL;AAnCE;EACC,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;AAqCH;AAlCI;EACC,gDAAA;AAoCL;;AA3BA;EACC,wBAAA;AA8BD;;AA3BA;EACC,oCAAA;EACA,yBAAA;EAEA,gBAAA;EACA,cAAA;EACA,gBAAA;AA6BD;;AA1BA;EACC,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;EAEA,gBAAA;EACA,cAAA;AA4BD;;AAzBA;EACC,oCAAA;EAEA,gBAAA;EACA,cAAA;EACA,gBAAA;AA2BD;;AAvBC;EACC,2BAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;AA0BF;;AAtBA;EACC,gBAAA;EACA,kBAAA;AAyBD;AAvBC;EACC,kBAAA;EACA,OAAA;AAyBF;;AArBA;EACC,wCAAA;EACA,oCAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAwBD;AAtBC;EACC,cAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAwBF;;AAPA;EACC,aAAA;EACA,eAAA;AAUD;AATC;EACC,kBAAA;AAWF;;AAMA;EACI,aAAA;EACH,oCAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AAHD;AAKC;EACC,oBAAA;AAHF;AAOC;EACC,2BAAA;AALF;;AAUA;EAEC,eAAA;EACA,oCAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,yBAAA;AARD;AAUC;EACC,aAAA;EACA,eAAA;AARF;AAUE;EACC,oBAAA;AARH;;AAaA;EACC,WAAA;AAVD","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\t--color-white-2: #FBFCFE;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-5: #0042A6;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-09: #CCEDFF;\n\t--color-mima-light: #EEF2F5;\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffaa00;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #f7d1cd;\n\t--color-deep-red: #9f0000;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #d1d1d1;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-grey-6: #9898AB;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-6: #2a2828;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-red: #FFE8E8;\n\t--color-light-grey: #F3F3FF;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #FBFCFE;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n$color-grey-6:#9898AB;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);\n","@import './variables/variables';\n\n.form {\n\tdisplay: block;\n\n\t&__group:not(:last-child) {\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__input {\n\t\tfont-size: $default-font-size;\n\t\tfont-family: inherit;\n\t\tcolor: var(--color-dark);\n\t\tpadding-left: 2rem;\n\t\twidth: 100%;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder: 1px solid var(--color-dark);\n\t\tdisplay: block;\n\t\tmargin-top: 0.5rem;\n\n\t\t&:focus,\n\t\t&:focus-visible,\n\t\t&:focus-within {\n\t\t\tcolor: var(--color-dark);\n\t\t\tborder: 1px solid $color-primary;\n\t\t}\n\n\t\t&_filter {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tfont-family: inherit;\n\t\t\tcolor: var(--color-dark);\n\t\t\tpadding-left: 2rem;\n\t\t\twidth: 100%;\n\t\t\theight: 4rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tborder: 1px solid var(--color-dark);\n\t\t\tdisplay: block;\n\t\t\tmargin-top: 0.5rem;\n\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tcolor: var(--color-dark);\n\t\t\t\tborder: 1px solid $color-primary;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__label {\n\t\tfont-size: $default-font-small;\n\t\tfont-family: inherit;\n\t\tpadding-left: 2rem;\n\t\tbox-sizing: border-box;\n\t\twidth: 38rem;\n\t}\n\n\t&__calendar {\n\t\tfont-family: inherit;\n\t\tfont-size: 1.4rem;\n\t\tbackground-color: var(--color-white);\n\t\tcolor: var(--color-dark);\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tborder-radius: 1rem;\n\t\tborder: none;\n\t\twidth: 25rem;\n\t\theight: 27.5rem;\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\tbox-sizing: border-box;\n\t\tpadding: 5px;\n\n\t\t& > :nth-child(3) {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tleft: 1rem;\n\t\t\ttop: 1rem;\n\t\t\tborder-radius: 0.8rem;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-4);\n\t\t\t}\n\n\t\t\tspan::before {\n\t\t\t\tright: -0.3rem;\n\t\t\t\ttop: 0.7rem;\n\t\t\t}\n\t\t}\n\t\t& > :nth-child(4) {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tright: 1rem !important;\n\t\t\ttop: 1rem;\n\t\t\tborder-radius: 0.8rem;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-4);\n\t\t\t}\n\t\t\tspan::before {\n\t\t\t\tleft: -0.3rem;\n\t\t\t\ttop: 0.7rem;\n\t\t\t}\n\t\t}\n\n\t\t& > :nth-child(5) {\n\t\t\twidth: 100%;\n\t\t\tfont-family: 'Montserrat';\n\t\t\tfont-size: 1.4rem;\n\t\t\tbackground-color: var(--color-light);\n\n\t\t\t& > :nth-child(1) {\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t& > :nth-child(1) {\n\t\t\t\t\tfont-size: 1.4rem;\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\n\t\t\t\t& > :nth-child(3) {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tgrid-template-columns: repeat(7, 1fr);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& > :nth-child(2) {\n\t\t\t\t& > :nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t}\n\t\t\t\t& > * {\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tgrid-template-columns: repeat(7, 1fr);\n\t\t\t\t\theight: 3rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& > :nth-child(6) {\n\t\t\tfont-family: 'Montserrat';\n\t\t\tfont-size: var(--default-font-small); \n\t\t\tposition: absolute;\n\t\t\tright: -85px;\n\n\t\t\t& > :nth-child(1) {\n\t\t\t\t& > * {\n\t\t\t\t\tfont-size: var(--default-font-xsmall) !important; \n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// When form is filled\n\n.filled {\n\tcolor: var(--color-dark);\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\t// padding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n\tmax-width: 38rem;\n}\n\n.note {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: var(--default-font-xsmall);\n\tcolor: var(--color-primary);\n\t// padding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.pageCount {\n\tfont-size: var(--default-font-small);\n\t// padding-left: 2rem;\n\tfont-weight: 700;\n\tmargin: 1rem 0;\n\tmax-width: 38rem;\n}\n// Success\n.success {\n\t&__h3 {\n\t\tcolor: var(--color-success);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\t\tline-height: 3.5rem;\n\t}\n}\n\n.iconAlign {\n\tmax-height: 6rem;\n\tposition: relative;\n\n\t& > :nth-child(2) {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t}\n}\n\n.tag {\n\tbackground-color: var(--color-primary-3);\n\tfont-size: var(--default-font-small);\n\theight: 4rem;\n\tpadding: 0.5rem 1rem;\n\tborder-radius: 8px;\n\twidth: 15rem;\n\tmargin-top: 1rem;\n\tmargin-right: 1rem;\n\n\t&_close {\n\t\tdisplay: block;\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tline-height: 16px;\n\t\ttext-align: center;\n\t\tborder-radius: 50%;\n\t}\n}\n\n\n// .tags{\n//     margin: 20px auto;\n//     display: flex;\n//     flex-wrap: wrap;\n//     overflow: hidden;\n//     width: 70%;\n//     min-width: 80%;\n//     border: 1px rgb(173, 162, 162) solid;\n//     border-radius: 5px;\n//     color: black;\n// }\n\n.tags {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n}\n\n// .single-tag{\n//     list-style: none;\n//     display: flex;\n//     align-items: center;\n//     margin: 7px 0 7px 14px;\n//     padding: 0 10px;\n//     padding-right: 5px;\n//     border: 1.5px solid #764abc;\n//     border-radius: 5px;\n//     white-space: nowrap;\n//     color: #764abc;\n// }\n\n.singleTag{\n    display: flex;\n\tfont-size: var(--default-font-small);\n\talign-items: center;\n\tbackground-color: var(--color-primary-3);\n\tpadding: 0.5rem;\n\tborder-radius: 0.5rem;\n\tcursor: pointer;\n\tmargin-bottom: 0.5rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 0.5rem;\n\t}\n\n\t\n\t&:hover {\n\t\tcolor: var(--color-primary);\n\t}\n\t\n}\n\n.suggestions {\n\t\n\tpadding: 0.5rem;\n\tfont-size: var(--default-font-small);\n\tcursor: pointer;\n\tbackground-color: var(--color-dark);\n\tborder-radius: 0.5rem;\n\tcolor: var(--color-white);\n\n\t&__all {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\n\t\t&>:not(:last-child) {\n\t\t\tmargin-right: 0.5rem;\n\t\t}\n\t}\n}\n\n.dateInput {\n\twidth: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `MimaInput_form__HrJaF`,
	"form__group": `MimaInput_form__group__WVOmY`,
	"form__input": `MimaInput_form__input__r5iYU`,
	"form__input_filter": `MimaInput_form__input_filter__zDB96`,
	"form__label": `MimaInput_form__label__FIG4x`,
	"form__calendar": `MimaInput_form__calendar__BG5qm`,
	"filled": `MimaInput_filled__lg89T`,
	"error": `MimaInput_error__QkKJM`,
	"note": `MimaInput_note__rddKG`,
	"pageCount": `MimaInput_pageCount__q1trw`,
	"success__h3": `MimaInput_success__h3__1dGfk`,
	"iconAlign": `MimaInput_iconAlign__3NiB0`,
	"tag": `MimaInput_tag__HOPrF`,
	"tag_close": `MimaInput_tag_close__CPSWl`,
	"tags": `MimaInput_tags__JdTMp`,
	"singleTag": `MimaInput_singleTag__G0kUc`,
	"suggestions": `MimaInput_suggestions__aMe2F`,
	"suggestions__all": `MimaInput_suggestions__all__1BQjb`,
	"dateInput": `MimaInput_dateInput__JI0Z8`
};
export default ___CSS_LOADER_EXPORT___;
